import { Link } from "react-router-dom";
import { articles, stats } from "@/mocks/gossip";
import { formatHeat } from "@/utils/gossip";

const TOP_LIST = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20editorial%20composition%20of%20warm%20amber%20and%20crimson%20stage%20spotlights%20cutting%20through%20soft%20haze%20over%20a%20dark%20moody%20background%2C%20subtle%20film%20grain%20texture%2C%20elegant%20minimal%20magazine%20cover%20aesthetic%2C%20deep%20shadows%20with%20golden%20highlights%2C%20no%20people%2C%20high%20detail%2C%20harmonious%20balanced%20composition&width=1600&height=900&seq=guatian-hero-01&orientation=landscape"
        alt="看料吃瓜社首屏：温暖光影构成的编辑风格背景"
        title="看料吃瓜 - 热门大瓜与劲爆猛料汇总"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/65 to-foreground-950/85"></div>

      <div className="relative h-full w-full px-4 md:px-6 flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 w-full items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/40 text-accent-200 text-xs font-label mb-5">
              <i className="ri-pulse-line"></i>
              实时更新 · 今日已整理 20+ 条瓜料
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              看料吃瓜：热门大瓜、劲爆猛料与深水硬核内容一网打尽
            </h1>
            <p className="mt-5 text-sm md:text-base text-background-200/90 leading-relaxed max-w-2xl">
              看料吃瓜社把散落在各处的热点线索、时间线与前因后果整理成清晰的板块。想找看料吃瓜大瓜和猛料，这里直接给你最全的瓜源汇总，不用东翻西找，一次看够。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/hot"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-label font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-base"></i>
                进入猛料区
              </Link>
              <Link
                to="/topics"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-label font-medium rounded-md bg-background-50/10 border border-background-50/30 text-background-50 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line text-base"></i>
                浏览专题分类
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5 max-w-2xl">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="font-label text-[11px] text-background-300 mb-1.5">{item.label}</dt>
                  <dd className="font-heading text-2xl font-bold text-accent-300">
                    {item.value}
                    <span className="text-xs font-label text-background-300 ml-1">{item.unit}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5 animate-fade-up">
            <div className="bg-foreground-950/60 backdrop-blur border border-background-50/15 rounded-lg p-5 md:p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="font-heading text-base font-semibold text-background-50 inline-flex items-center gap-2">
                  <i className="ri-bar-chart-2-line text-accent-400"></i>
                  今日热议榜
                </h2>
                <span className="text-[11px] font-label text-background-400">按讨论热度排序</span>
              </div>
              <ol className="space-y-1">
                {TOP_LIST.map((item, index) => (
                  <li key={item.id}>
                    <Link
                      to={`/hot/${item.id}`}
                      className="group flex items-start gap-3 py-2.5 px-2 -mx-2 rounded-md hover:bg-background-50/10 transition-colors cursor-pointer"
                    >
                      <span
                        className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center font-label text-xs font-bold mt-0.5 ${
                          index < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-50/15 text-background-200"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm text-background-100 leading-snug line-clamp-2 group-hover:text-accent-300 transition-colors">
                          {item.title}
                        </span>
                        <span className="mt-1 flex items-center gap-3 text-[11px] font-label text-background-400">
                          <span>{item.categoryLabel}</span>
                          <span className="inline-flex items-center gap-1">
                            <i className="ri-fire-line text-primary-400"></i>
                            {formatHeat(item.heat)}
                          </span>
                        </span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}